(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-atomicfu.js', './coil-root-coil-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-atomicfu.js'), require('./coil-root-coil-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'coil-root-coil'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'coil-root-coil'.");
    }
    if (typeof globalThis['coil-root-coil-core'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil'. Its dependency 'coil-root-coil-core' was not found. Please, check whether 'coil-root-coil-core' is loaded prior to 'coil-root-coil'.");
    }
    globalThis['coil-root-coil'] = factory(typeof globalThis['coil-root-coil'] === 'undefined' ? {} : globalThis['coil-root-coil'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-atomicfu'], globalThis['coil-root-coil-core']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_io_coil_kt_coil3_coil_core) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var ImageLoader = kotlin_io_coil_kt_coil3_coil_core.$_$.g;
  var isInterface = kotlin_kotlin.$_$.rg;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var Builder_init_$Create$ = kotlin_io_coil_kt_coil3_coil_core.$_$.m;
  var Key = kotlin_io_coil_kt_coil3_coil_core.$_$.f;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(Factory, 'Factory');
  initMetadataForObject(SingletonImageLoader, 'SingletonImageLoader');
  initMetadataForClass(sam$coil3_SingletonImageLoader_Factory$0, 'sam$coil3_SingletonImageLoader_Factory$0', VOID, VOID, [Factory, FunctionAdapter]);
  //endregion
  var DefaultSingletonImageLoaderFactory;
  function get_DefaultSingletonImageLoaderKey() {
    _init_properties_SingletonImageLoader_kt__bjc86b();
    return DefaultSingletonImageLoaderKey;
  }
  var DefaultSingletonImageLoaderKey;
  function Factory() {
  }
  function SingletonImageLoader() {
    SingletonImageLoader_instance = this;
    this.uxk_1 = atomic$ref$1(null);
  }
  protoOf(SingletonImageLoader).vxk = function (factory) {
    var value = this.uxk_1.kotlinx$atomicfu$value;
    if (!(value == null) ? isInterface(value, ImageLoader) : false) {
      if (get_isDefault(value)) {
        // Inline function 'kotlin.error' call
        var message = "The singleton image loader has already been created. This indicates that 'setSafe' is being called after the first 'get' call. Ensure that 'setSafe' is called before any Coil API usages (e.g. `load`, `AsyncImage`, `rememberAsyncImagePainter`, etc.).";
        throw IllegalStateException_init_$Create$(toString(message));
      }
      return Unit_instance;
    }
    this.uxk_1.atomicfu$compareAndSet(value, factory);
  };
  var SingletonImageLoader_instance;
  function SingletonImageLoader_getInstance() {
    if (SingletonImageLoader_instance == null)
      new SingletonImageLoader();
    return SingletonImageLoader_instance;
  }
  function get_isDefault(_this__u8e3s4) {
    _init_properties_SingletonImageLoader_kt__bjc86b();
    return !(_this__u8e3s4.ixe().cxe_1.wxc(get_DefaultSingletonImageLoaderKey()) == null);
  }
  function sam$coil3_SingletonImageLoader_Factory$0(function_0) {
    this.wxk_1 = function_0;
  }
  protoOf(sam$coil3_SingletonImageLoader_Factory$0).q3 = function () {
    return this.wxk_1;
  };
  protoOf(sam$coil3_SingletonImageLoader_Factory$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Factory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$coil3_SingletonImageLoader_Factory$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function DefaultSingletonImageLoaderFactory$lambda(context) {
    _init_properties_SingletonImageLoader_kt__bjc86b();
    // Inline function 'kotlin.apply' call
    var this_0 = Builder_init_$Create$(context);
    this_0.fxd_1.txc(get_DefaultSingletonImageLoaderKey(), Unit_instance);
    return this_0.g3d();
  }
  var properties_initialized_SingletonImageLoader_kt_6s3swr;
  function _init_properties_SingletonImageLoader_kt__bjc86b() {
    if (!properties_initialized_SingletonImageLoader_kt_6s3swr) {
      properties_initialized_SingletonImageLoader_kt_6s3swr = true;
      var tmp = DefaultSingletonImageLoaderFactory$lambda;
      DefaultSingletonImageLoaderFactory = new sam$coil3_SingletonImageLoader_Factory$0(tmp);
      DefaultSingletonImageLoaderKey = new Key(Unit_instance);
    }
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Factory;
  _.$_$.b = SingletonImageLoader_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=coil-root-coil.js.map
